import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ spacing }: Theme) => createStyles({
  menuItem: {
    marginBottom: spacing(1),
  },
  divider: {
    margin: spacing(2),
  },
});

export default styles;
